import env from '~/libs/env'

/**
 * ApplicationExperienceService
 *
 * Facilitates api calls for Application experience, including application configs and navigation.
 *
 * Requires a store passed so it has access to the correct `$axios` in context
 * for any XHR requests. Helps manage the interface of saving answers between
 * local storage and the actual service.
 */
export class ApplicationExperienceService {
    constructor($axios, $axiosWithRetry) {
      this.$axios = $axios
      this.$axiosWithRetry = $axiosWithRetry
    }
    async getApplicationConfigData({ borrowerId, tenantId, entrypointIdentifier = null, anonymousId = null, moduleIdentifier = null, direction = null }) {
      let url = entrypointIdentifier
        ? `${env('apiUrl')}/application-config/identifier/${entrypointIdentifier}/tenant/${tenantId}`
        : `${env('apiUrl')}/tenant-application-experience/tenant/${tenantId}`

      if (borrowerId) {
        url += `/borrower/${borrowerId}`
      }

      let error = null
      const params = { identifier: moduleIdentifier, moduleIdentifier, anonymousId, direction }
      const response = await this.$axiosWithRetry.get(url, { params }).catch(err => error = err)

      return { data: response?.data?.data ?? null, error }
    }
}

export default {
  ApplicationExperienceService
}
